{
  "greeting": {
    "salam": "Assalamualaikum",
    "salamWithName": "Assalamualaikum, {{name}}"
  },
  "dock": {
    "saved": "Disimpan",
    "savedVerses": "Ayat disimpan",
    "tasks": "Tugasan",
    "notes": "Nota"
  },
  "actions": {
    "save": "Simpan",
    "cancel": "Batal",
    "close": "Tutup",
    "delete": "Padam",
    "rename": "Namakan semula",
    "dismiss": "Tolak",
    "loading": "Memuatkan…",
    "reload": "Muat semula",
    "retry": "Cuba lagi",
    "expand": "Kembangkan",
    "collapse": "Kecilkan"
  },
  "nav": {
    "appNavigation_aria": "Navigasi aplikasi"
  },
  "tabs": {
    "home": "Utama",
    "tasks": "Tugas",
    "notes": "Nota",
    "more": "Lagi"
  },
  "more": {
    "daily": "Harian",
    "account": "Akaun",
    "savedVerses": "Ayat disimpan",
    "qibla": "Kiblat",
    "prayerTimes": "Waktu Solat & Peringatan",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Diurus melalui akaun Rhemn anda",
    "upgrade": "Naik taraf",
    "privacyPolicy": "Dasar Privasi",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Kembali",
    "deleteAccount": "Padam akaun"
  },
  "reflection": {
    "dismiss_aria": "Tolak renungan"
  },
  "app": {
    "loading_aria": "Rhemn sedang dimuatkan",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Urus langganan Rhemn Pro anda di web. Pro dibuka secara automatik di sini apabila anda log masuk dengan akaun yang dilanggan."
  },
  "header": {
    "qiblaDirection_aria": "Arah kiblat",
    "prayerTimes_aria": "Waktu solat",
    "prayerTimesTitle": "Waktu Solat",
    "method": "Kaedah",
    "methodHelp": "Kaedah mempengaruhi waktu yang dikira"
  },
  "search": {
    "search_aria": "Cari",
    "searchLabel": "Cari",
    "searchWeb_placeholder": "Cari di web"
  },
  "focus": {
    "input_placeholder": "Apa yang paling penting hari ini?",
    "example_worship": "Solat dengan khusyuk, tanpa tergesa-gesa",
    "example_kindness": "Menelefon ibu hanya untuk mendengarnya",
    "example_reflect": "Renungkan niat anda bersama ayat hari ini",
    "saveIntention_aria": "Simpan niat",
    "celebration": "🤲 Mashallah"
  },
  "profile": {
    "profileFallback": "Profil",
    "profileAndAccount_aria": "Profil dan akaun",
    "profileDialog_aria": "Profil",
    "editName_aria": "Edit nama anda",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Urus langganan",
    "manageSubscription_aria": "Urus langganan Rehmn Pro anda",
    "anonymousAnalytics": "Analitik tanpa nama",
    "anonymousAnalyticsNote": "Agregat sahaja — tidak pernah dikaitkan dengan anda",
    "shareAnalytics_aria": "Kongsi analitik penggunaan tanpa nama",
    "signOut": "Log Keluar",
    "signingOut": "Sedang log keluar…",
    "signOut_aria": "Log keluar daripada Rehmn",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "Memuatkan latar belakang...",
    "fallbackNotice": "Menggunakan imej sandaran (API Unsplash tidak tersedia)",
    "noImage": "Tiada imej latar belakang tersedia",
    "error": "Ralat: {{message}}",
    "photoByOnUnsplash": "Foto oleh <photographer>{{name}}</photographer> di <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Sesuatu tidak kena",
    "fallbackMessage": "Ralat yang tidak dijangka berlaku."
  },
  "theme": {
    "switchToLight_title": "Tukar ke mod cerah",
    "switchToDark_title": "Tukar ke mod gelap"
  },
  "upgradeCta": {
    "upgradeToPro": "Naik taraf ke Pro",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / bulan",
    "pricePerYear": "{{price}} / tahun",
    "purchasePending": "Menunggu kelulusan. Pro akan diaktifkan secara automatik setelah pembelian diluluskan.",
    "storeUnavailable": "App Store tidak dapat dihubungi buat masa ini. Cuba lagi sebentar nanti.",
    "purchaseFailed": "Pembelian tidak dapat diselesaikan. Cuba lagi sebentar nanti."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · Diskaun 25% tahun pertama",
    "title": "Untuk waktu di antara solat anda.",
    "body": "Nota suara yang ditranskripsi, diringkaskan dan menjadi tugasan. Perancang harian yang dibina mengikut waktu solat anda. Nota dengan AI.",
    "price": "$29.99",
    "period": "untuk tahun pertama",
    "priceIos": "Diskaun 25% tahun pertama",
    "terms": "Kemudian $39.99 setahun. Kod {{code}} telah digunakan untuk anda.",
    "termsIos": "Diperbaharui pada harga tahunan biasa. Gunakan kod {{code}} di App Store.",
    "free": "Waktu solat, kiblat, ayat harian dan tugasan kekal percuma.",
    "cta": "Naik taraf ke Pro",
    "dismiss": "Bukan sekarang"
  },
  "planChooser": {
    "monthly": "Bulanan",
    "yearly": "Tahunan",
    "yearlyValue": "Empat bulan daripada kami.",
    "freeNote": "Waktu solat, Kiblat, ayat harian dan tugasan adalah percuma. Rhemn Pro menambah:",
    "includes_planner": "Rancangan hari yang disusun mengelilingi lima waktu solat, dan “Rancang hari saya”",
    "includes_insights": "Quran Insights — tanya apa-apa tentang sesuatu ayat dan baca konteksnya",
    "includes_reflections": "Renungan ayat harian, ditulis untuk niat yang anda tetapkan",
    "includes_notes": "Nota dan nota suara, dengan ringkasan serta kemasan AI",
    "includes_extras": "Ayat disimpan, kad ayat, rentetan hari dan ramalan 5 hari",
    "renewsMonthly": "Diperbaharui setiap bulan sehingga dibatalkan",
    "renewsYearly": "Diperbaharui setiap 12 bulan sehingga dibatalkan",
    "continue": "Teruskan",
    "renewalTerms": "Bayaran dicaj ke Apple ID anda semasa pengesahan. Langganan diperbaharui secara automatik melainkan pembaharuan automatik dimatikan sekurang-kurangnya 24 jam sebelum tempoh berakhir. Urus atau batalkan bila-bila masa dalam tetapan Apple ID.",
    "retry": "Cuba lagi"
  },
  "streak": {
    "badge_aria": "Istiqamah harian — {{count}} hari",
    "title": "Istiqamah harian",
    "daysWithCount": "Istiqamah {{count}} hari",
    "start": "Mulakan hari ini — luangkan seketika bersama ayat atau tandakan solat.",
    "prayedToday": "Sudah solat hari ini",
    "readVerse": "Sudah membaca ayat hari ini",
    "autoHint": "Ayat ditanda dengan sendirinya apabila anda meluangkan seketika bersamanya.",
    "milestoneTitle": "{{count}} hari dengan niat",
    "milestoneBody": "Alhamdulillah. Kongsikan pencapaian ini — insan yang anda sayangi mungkin turut memulakannya.",
    "share": "Kongsi",
    "dismiss": "Bukan sekarang",
    "cardLabel": "hari dengan niat",
    "shareCaption": "{{count}} hari bermula dengan niat — rhemn.com",
    "imageSaved": "Imej disimpan.",
    "couldNotCreateImage": "Tidak dapat mencipta imej. Sila cuba lagi."
  },
  "qibla": {
    "compassIcon_aria": "Ikon kompas",
    "title": "Arah Kiblat",
    "locationUnavailable": "Lokasi tidak tersedia",
    "locating": "Mengesan lokasi…",
    "compass_aria": "Kompas kiblat",
    "directionN": "U",
    "directionE": "T",
    "directionS": "S",
    "directionW": "B",
    "facingQibla": "Menghadap Kiblat",
    "enableLiveCompass": "Dayakan Kompas Langsung",
    "enableLiveCompassNote": "Menggunakan penderia gerakan supaya anak panah mengikut ketika anda berpaling — bukan lokasi",
    "directionToMecca": "Arah ke Mekah",
    "enableLocation": "Dayakan akses lokasi untuk mengira arah",
    "hintLive": "Anak panah menjejak orientasi peranti anda secara masa nyata",
    "hintStatic": "Arah dari Utara — gunakan dengan kompas untuk arah yang tepat",
    "live": "Langsung",
    "footerVerse": "\"Maka hadapkanlah wajahmu ke arah Masjidil Haram\" – Quran 2:144"
  },
  "legal": {
    "links_aria": "Perundangan",
    "termsOfUse": "Terma Penggunaan",
    "privacyPolicy": "Dasar Privasi"
  },
  "auth": {
    "signInForPro": "Log masuk dahulu — Pro anda mengikut anda ke mana-mana."
  },
  "integrations": {
    "row": {
      "label": "Kalendar & tugasan",
      "caption": "Disambungkan",
      "subNone": "Tidak disambungkan",
      "subFree": "Google Calendar, Google Tasks dan lain-lain",
      "subAttention": "{{provider}} memerlukan perhatian",
      "subPaused": "Penyegerakan dijeda"
    },
    "list": {
      "title": "Kalendar & tugasan",
      "subtitle": "Bawa mesyuarat dan tugasan anda ke dalam hari anda.",
      "footnote": "Rhemn hanya membaca apa yang diperlukan, dan tidak pernah menyimpan acara anda.",
      "privacy": "Dasar Privasi",
      "connect": "Sambung",
      "connect_aria": "Sambung {{what}}",
      "checking": "Menyemak…",
      "loadError": "Sambungan anda tidak dapat dimuatkan.",
      "tryAgain": "Cuba lagi",
      "offline": "Anda tidak disambungkan ke internet. Sambung apabila anda kembali dalam talian.",
      "unavailable": "Kalendar & tugasan tidak tersedia buat masa ini.",
      "disconnected": "{{provider}} diputuskan.",
      "google": {
        "name": "Google",
        "sub": "Kalendar dan Tugasan",
        "what": "Google Calendar dan Google Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Tugasan dan projek",
        "what": "Todoist"
      },
      "apple": {
        "name": "Kalendar & Peringatan",
        "subNative": "Pada {{device}} ini",
        "subSafari": "Dalam apl Rhemn untuk iPhone dan Mac"
      },
      "synced": "Disegerakkan {{when}}",
      "connectedSub": "Disambungkan",
      "syncing": "Menyegerak…",
      "reconnectSub": "Sambung semula untuk terus menyegerak",
      "errorSub": "Penyegerakan terakhir tidak selesai",
      "pausedSub": "Dijeda · Rhemn Pro telah tamat"
    },
    "explainer": {
      "google": {
        "title": "Sambungkan Google Calendar dan Google Tasks",
        "p1Lead": "Kalendar anda, baca sahaja",
        "p1Body": "Rhemn memaparkan acara anda dalam hari anda dan mengetahui bila anda sibuk. Ia tidak menyimpannya.",
        "p2Lead": "Google Tasks, dua hala",
        "p2Body": "Senarai yang anda pilih kekal disegerakkan, jadi anda boleh menandakannya selesai di mana-mana sahaja.",
        "p3Lead": "Boleh dibatalkan bila-bila masa",
        "p3Body": "Putuskan sambungan bila-bila masa, di sini atau dalam Akaun Google anda.",
        "footnote": "Google akan menunjukkan dengan tepat apa yang diminta oleh Rhemn."
      },
      "todoist": {
        "title": "Sambungkan Todoist",
        "p1Lead": "Projek anda, dua hala",
        "p1Body": "Projek yang anda pilih kekal disegerakkan, jadi anda boleh menandakannya selesai di mana-mana sahaja.",
        "p2Lead": "Cara ia dipetakan",
        "p2Body": "Keutamaan Todoist menjadi Kritikal, Tinggi, Sederhana dan Rendah. Sub-tugas yang lebih dalam daripada satu peringkat dipaparkan sebagai langkah di bawah tugas utamanya.",
        "p3Lead": "Boleh dibatalkan bila-bila masa",
        "p3Body": "Putuskan sambungan bila-bila masa, di sini atau dalam tetapan Todoist.",
        "cta": "Teruskan ke Todoist",
        "footnote": "Todoist akan meminta anda mengesahkan."
      },
      "skip": "Bukan sekarang",
      "cancel": "Batal",
      "waiting": "Menunggu {{provider}}…",
      "safariWaiting": "Selesaikan dalam tab baharu, kemudian kembali ke sini.",
      "safariReopen": "Buka semula tab",
      "denied": "{{provider}} tidak memberikan akses, jadi tiada apa yang disambungkan.",
      "error": "Tidak dapat menyambung ke {{provider}}. Cuba lagi sebentar."
    },
    "detail": {
      "back_aria": "Kembali ke Kalendar & tugasan",
      "syncNow": "Segerak sekarang",
      "intro": "Pilih apa yang disegerakkan oleh Rhemn. Anda boleh mengubahnya bila-bila masa.",
      "taskLists": "Senarai tugasan",
      "projects": "Projek",
      "reminders": "Peringatan",
      "calendars": "Kalendar",
      "rhemnCalendarSub": "Waktu solat anda, tidak dikira sebagai sibuk",
      "loading": "Memuatkan…",
      "loadError": "Senarai anda tidak dapat dimuatkan.",
      "emptyGoogle": "Tiada senarai tugasan dalam Google Tasks.",
      "emptyTodoist": "Tiada projek dalam Todoist.",
      "addError": "{{name}} tidak dapat ditambah. Cuba lagi.",
      "removed": "Dialih keluar daripada Rhemn. Masih ada dalam {{provider}}.",
      "undo": "Buat asal",
      "prayerTimes": "Tambah waktu solat ke kalendar anda",
      "prayerTimesSub": "Menambah lima waktu solat ke kalendar bernama Rhemn, untuk 7 hari akan datang, supaya orang lain tidak menempah masa itu.",
      "prayerTimesOn": "Hidup. Ditambah sehingga {{date}}.",
      "prayerTimesWaiting": "Menunggu Google…",
      "prayerTimesDenied": "Google tidak membenarkannya. Tiada apa yang ditambah.",
      "prayerTimesRemoveAsk": "Alih keluar waktu solat Rhemn daripada kalendar anda?",
      "prayerTimesKeep": "Kekalkan",
      "prayerTimesRemove": "Alih keluar",
      "meetingPrompts": "Peringatan mesyuarat",
      "meetingPromptsSub": "Apabila mesyuarat dengan pautan akan bermula, ia menawarkan untuk mengambil nota.",
      "busyFootnote": "\"Rancang hari saya\" hanya melihat bila anda sibuk, tidak pernah melihat kandungan mesyuarat anda.",
      "todoistFootnote": "Keutamaan Todoist menjadi Kritikal, Tinggi, Sederhana dan Rendah. Sub-tugas yang lebih dalam daripada satu peringkat dipaparkan sebagai langkah di bawah tugas utamanya.",
      "reauth": "{{provider}} berhenti membenarkan Rhemn menyegerak. Ini berlaku apabila akses dialih keluar atau kata laluan anda berubah.",
      "reconnect": "Sambung semula",
      "paused": "Penyegerakan dijeda kerana Rhemn Pro telah tamat. Senarai anda kekal seperti sebelumnya.",
      "calendarDenied": "Akses kalendar dimatikan.",
      "remindersDenied": "Akses peringatan dimatikan.",
      "disconnect": "Putuskan {{provider}}",
      "disconnectTitle": "Putuskan {{provider}}?",
      "disconnectBody": "Tiada apa yang dipadam dalam {{provider}}.",
      "disconnectRhemnCal": "Kalendar waktu solat Rhemn anda akan dialih keluar daripada Google Calendar.",
      "disconnectError": "Tidak dapat memutuskan {{provider}}. Cuba lagi sebentar.",
      "keepLists": "Kekalkan senarai saya dalam Rhemn",
      "keepListsSub": "Ia berhenti menyegerak dan menjadi senarai Rhemn biasa.",
      "removeLists": "Alih keluar daripada Rhemn",
      "removeListsSub": "Hanya salinan dalam Rhemn dialih keluar.",
      "disconnecting": "Memutuskan sambungan…",
      "appleStop": "Berhenti menggunakan Kalendar & Peringatan",
      "appleStopTitle": "Berhenti menggunakan Kalendar & Peringatan?",
      "appleStopBody": "Rhemn berhenti memaparkan acara dan peringatan anda. Untuk mengalih keluar aksesnya sepenuhnya, matikannya dalam Tetapan.",
      "justNow": "baru sahaja",
      "tasksScope": "Rhemn memerlukan kebenaran untuk melihat Google Tasks anda. Sambung semula dan tandakan Tugasan untuk membenarkannya.",
      "calendarsLoadError": "Kalendar anda tidak dapat dimuatkan.",
      "calendarsEmpty": "Tiada kalendar dalam akaun ini.",
      "calendarsScope": "Rhemn memerlukan kebenaran untuk melihat Google Calendar anda. Sambung semula dan tandakan Calendar untuk membenarkannya.",
      "prayerTimesError": "Waktu solat anda tidak dapat ditambah. Cuba lagi sebentar nanti.",
      "remindersEmpty": "Tiada senarai dalam Peringatan.",
      "openSettings": "Buka Tetapan",
      "appleStopCta": "Berhenti guna"
    },
    "locked": {
      "body": "Lihat mesyuarat anda dalam blok solat anda, dan kekalkan Google Tasks disegerakkan dengan Rhemn.",
      "googleName": "Google Calendar dan Google Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "peranti"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, disegerakkan dengan {{provider}}",
      "unlinkConfirm": "Alih keluar “{{name}}” daripada Rhemn? Ia kekal dalam {{provider}}.",
      "remove": "Alih keluar",
      "offline": "Luar talian · Perubahan akan disegerakkan ke {{provider}} apabila anda kembali.",
      "stillSyncing": "Masih menyegerak dengan {{provider}}…",
      "failed_other": "{{count}} perubahan tidak sampai ke {{provider}}.",
      "retry": "Cuba lagi",
      "needsReconnect": "{{provider}} memerlukan anda menyambung semula.",
      "paused": "Penyegerakan dijeda · Rhemn Pro telah tamat.",
      "upgrade": "Naik taraf",
      "notSynced": "Tidak disegerakkan",
      "notSynced_aria": "Tidak disegerakkan ke {{provider}}. Cuba lagi.",
      "remindersOff": "Rhemn tidak dapat mencapai Peringatan. Hidupkannya semula dalam Tetapan.",
      "dueToday": "Hari ini",
      "dueTomorrow": "Esok",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Sepanjang hari",
      "more": "+{{count}}",
      "more_aria": "Tunjukkan {{count}} lagi acara sepanjang hari",
      "less_aria": "Tunjukkan kurang acara sepanjang hari",
      "events_aria": "Acara",
      "event_aria": "{{start}} hingga {{end}}, {{title}}",
      "allDayEvent_aria": "Sepanjang hari, {{title}}",
      "untitled": "Sibuk",
      "now": "Sekarang · sehingga {{end}}",
      "until": "sehingga {{end}}",
      "into": "· hingga ke {{prayer}}",
      "loadError": "Kalendar anda tidak dapat dimuatkan.",
      "needsReconnect": "Google Calendar perlu disambung semula.",
      "scope": "Rhemn tidak dapat melihat Google Calendar anda. Sambung semula dan tandakan Calendar untuk membenarkannya.",
      "appleOff": "Rhemn tidak dapat melihat kalendar anda. Hidupkannya semula dalam Tetapan."
    },
    "plan": {
      "mostlyMeetings": "Kebanyakannya mesyuarat · {{duration}} lapang",
      "noFreeTime": "Tiada masa lapang",
      "aroundMeetings_other": "Dirancang di sekitar {{count}} mesyuarat.",
      "settledBusy": "Semuanya sudah muat di sekitar mesyuarat anda."
    },
    "meeting": {
      "group_aria": "Mesyuarat bermula",
      "now": "sekarang",
      "takeNotes": "Ambil nota",
      "takeNotes_aria": "Ambil nota untuk {{title}}",
      "dismiss_aria": "Tutup",
      "announce": "{{title}} bermula {{when}}.",
      "announceNow": "{{title}} sedang bermula.",
      "yourMeeting": "Mesyuarat anda"
    },
    "apple": {
      "primer": {
        "title": "Paparkan kalendar anda di sisi solat anda",
        "body": "Rhemn membaca acara dan peringatan pada {{device}} ini untuk meletakkannya dalam hari anda. Semuanya kekal pada peranti anda. Rancang hari saya hanya menggunakan masa anda sibuk.",
        "cta": "Teruskan",
        "skip": "Bukan sekarang",
        "footnote": "{{device}} akan bertanya dua kali, sekali untuk Kalendar dan sekali untuk Peringatan. Anda boleh mengubah kedua-duanya dalam Tetapan."
      }
    }
  }
}
